/// <reference lib="dom" />

/*
 * This is a stopgap function that takes a response from our list api and converts it into
 * normal string characters so we don't need to use dangerouslySetInnerHtml.
 */
export function temporaryHtmlToString(htmlString: string): string {
    if (typeof DOMParser !== 'undefined') {
        const parser = new DOMParser();
        const dom = parser.parseFromString(`<!doctype html><body>${htmlString}`, 'text/html');

        return dom.body?.textContent ?? decodeHtmlEntitiesWithoutDom(htmlString);
    }

    return decodeHtmlEntitiesWithoutDom(htmlString);
}

function decodeHtmlEntitiesWithoutDom(htmlString: string): string {
    return htmlString
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#0*39;/g, "'");
}
